import type { IDataViewFiltersLabels, IDataViewHeaderConfig } from '@/domains/investor/components/DataView/DataView.types'

export const GENERAL_MEETING_FILTERS_LABELS: IDataViewFiltersLabels = {
  categoryLabel: 'investor.generalMeeting.dataView.filters.category.label',
  searchLabel: 'investor.reports.search.label',
  searchPlaceholder: 'investor.reports.search.placeholder',
  searchSubmit: 'investor.reports.search.submit',
  yearLabel: 'investor.generalMeeting.dataView.filters.year.label',
  yearPlaceholder: 'investor.generalMeeting.dataView.filters.year.placeholder',
  monthLabel: 'investor.reports.filters.month.label',
  monthPlaceholder: 'investor.reports.filters.month.placeholder',
  resultsLabel: 'investor.reports.results.label',
  resultsUnit: 'investor.reports.results.unit',
  clearFilters: 'investor.reports.filters.clear',
}

export const GENERAL_MEETING_HEADER_CONFIG: IDataViewHeaderConfig = {
  text: 'investor.generalMeeting.heading',
  size: 'h5',
  position: 'center',
}
